import React from 'react'

import { compose, lifecycle, withState } from 'recompose'
import styled, { css, keyframes } from 'styled-components'

import ProgressSpinner from 'components/ProgressSpinner'
import { Heading } from 'components/typography'
import useWindowDimensions from 'hooks/useWindowDimensions'
import { style } from 'theme'

import { StyledBody, StyledCard } from './components'

type OuterProps = {
  closureItems?: string[]
  closureHeading: string
  isVisible: boolean
  isWebView: boolean
}

type InnerProps = {
  currentClosureItem: string
}

type MergedProps = OuterProps & InnerProps

const StyledHeading = styled(Heading)`
  line-height: 24px;
  text-align: center;
`
const Container = styled.div`
  margin: auto !important;
  width: 90%;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    height: auto;
  }
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;  
  }
  to {
    opacity: 1; 
  }
`

const TextContainer = styled.div`
  ${css`
    > p {
      animation: ${css`
        ${fadeInAnimation} 250ms ease-in-out
      `};
      animation-fill-mode: both;
    }
  `}
`

const Title = styled.p`
  min-height: 18px;
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 16px;
  text-align: center;
  color: ${style((theme) => theme.colors.stone)};
`

const Card = styled(StyledCard)<{ innerHeight?: number }>`
  justify-content: flex-start;
  @media screen and (max-width: ${style(
      (theme) => theme.breakpoints.sm - 1,
    )}px) {
    &&& {
      min-height: ${(props) => props.innerHeight}px;
    }
  }
`

// iterate through closure items for screen animation
const enhance = compose<MergedProps, OuterProps>(
  withState('currentClosureItem', 'setCurrentClosureItem', null),
  lifecycle<any, {}>({
    componentDidMount() {
      let i = 0
      const interval = setInterval(() => {
        this.props.setCurrentClosureItem(this.props.closureItems[i])
        i++
        if (i >= this.props.closureItems.length) {
          clearInterval(interval)
        }
      }, 600)
    },
  }),
)

const LoadingScreen: React.FC<MergedProps> = ({
  currentClosureItem,
  closureHeading,
  isWebView,
}) => {
  const { height } = useWindowDimensions()
  return (
    <Card isWebView={isWebView} innerHeight={isWebView ? height : undefined}>
      <Container>
        <ProgressSpinner />
        <StyledBody>
          <StyledHeading>{closureHeading}</StyledHeading>
          <TextContainer>
            <Title>{currentClosureItem}</Title>
          </TextContainer>
        </StyledBody>
      </Container>
    </Card>
  )
}

export default enhance(LoadingScreen)
